import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import {
	ContactTitleEnum,
	CountryDto,
} from '@splitsecondconnect/ultramarine-shared';
import { BehaviorSubject } from 'rxjs';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';
import { MoreSectionsComponent } from 'app/shared/components/more-sections/more-sections.component';
import { SelectItem } from 'app/shared/models/select-item.type';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { SingleDropdownComponent } from '../../../../../../shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { ContactModel } from '../../../../../../shared/models/contact-details.model';
import { CONTACT_TITLE } from '../../../../../../shared/select-items/contact-details-select-items';
import { SettingsService } from '../../../../settings/services/settings.service';

@Component({
	selector: 'app-customers-contact-company',
	templateUrl: 'customers-contact-company.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SingleDropdownComponent,
		SectionWrapperComponent,
		MoreSectionsComponent,
	],
})
export class CustomersContactCompanyComponent
	extends BaseSectionComponent<ContactModel>
	implements OnInit
{
	countries = inject(SettingsService).countriesSelectItems;
	public contactTitleOptions: SelectItem<ContactTitleEnum>[];
	protected _skipCount: number = 0;
	public countries$: BehaviorSubject<CountryDto[]> = new BehaviorSubject<
		CountryDto[]
	>(null);

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.contactTitleOptions = CONTACT_TITLE;
		this.detailsForm = this._formBuilder.group({
			companyName: [null],
			email: [null],
			address1: [null],
			address2: [null],
			phoneFax: [null],
			phoneLandline: [null],
			phoneMobile: [null],
			city: [null],
			postCode: [null],
			poBox: [null],
			county: [null],
			state: [null],
			countryId: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			companyName: this.recordData().contactCompanyName,
			email: this.recordData().contactEmail,
			address1: this.recordData().contactAddress1,
			address2: this.recordData().contactAddress2,
			phoneFax: this.recordData().contactPhoneFax,
			phoneLandline: this.recordData().contactPhoneLandline,
			phoneMobile: this.recordData().contactPhoneMobile,
			city: this.recordData().contactCity,
			postCode: this.recordData().contactPostCode,
			poBox: this.recordData().contactPoBox,
			county: this.recordData().contactCounty,
			state: this.recordData().contactState,
			countryId: this.recordData().contactCountryId,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<ContactModel> {
		return {
			contactId: this.recordData().contactId,
			contactCompanyName: this.detailsForm.controls.companyName.value,
			contactEmail: this.detailsForm.controls.email.value,
			contactAddress1: this.detailsForm.controls.address1.value,
			contactAddress2: this.detailsForm.controls.address2.value,
			contactPhoneFax: this.detailsForm.controls.phoneFax.value,
			contactPhoneLandline: this.detailsForm.controls.phoneLandline.value,
			contactPhoneMobile: this.detailsForm.controls.phoneMobile.value,
			contactCity: this.detailsForm.controls.city.value,
			contactPostCode: this.detailsForm.controls.postCode.value,
			contactPoBox: this.detailsForm.controls.poBox.value,
			contactCounty: this.detailsForm.controls.county.value,
			contactState: this.detailsForm.controls.state.value,
			contactCountryId: this.detailsForm.controls.countryId.value,
		};
	}
}
